import React from 'react';

import type { OrganizationAllContent } from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, prettifyURL } from '@gitbook/spine-react';

import type { SitePreviewContent } from './getSiteURLForContent';
import { getSitePreviewURL } from './SitePreviewURL';

type SitePreviewButtonProps = {
    siteId: string;
    content: SitePreviewContent;
    orgAllContent: OrganizationAllContent;
} & Partial<Omit<ButtonProps, 'href' | 'target' | 'trailingIcon' | 'content'>>;

/**
 * Component to show a button opening a site preview URL.
 */
export function SitePreviewButton(props: SitePreviewButtonProps) {
    const { siteId, content, orgAllContent, ...rest } = props;

    const url = React.useMemo(
        () =>
            getSitePreviewURL({
                content,
                orgAllContent,
                siteId,
            }),
        [content, orgAllContent, siteId]
    );

    if (!url) {
        return null;
    }

    return (
        <Button
            trailingIcon={Icon.ExternalLink}
            href={url}
            target="_blank"
            label={prettifyURL(url)}
            {...rest}
        />
    );
}
